export default __webpack_public_path__ + "ddb2c272fe67b08fb5d1e035de0403e1.png";